import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('config.index', params);
    },
    get: (context, params) => {
        return apiService.get('config.detail', params);
    },
    create: (context, params) => {
        return apiService.post('config.index', params);
    },
    delete: (context, params) => {
        return apiService.delete('config.detail', params);
    },
    backup: (context, params) => {
        return apiService.download('config.backup', params);
    },
    restore: (context, params) => {
        return apiService.postForm('config.restore', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
